<template>
  <div class="toolbar-container">
    <!--Select All Tool-->
    <tool-button
      :icon="selectAllTool.icon"
      :tooltip="$t(selectAllTool.label)"
      :disabled="objects.selected === objects.total || !editMode"
      @buttonClick="emitEvent(selectAllTool.event)"
    />

    <!--Invert Selection Tool-->
    <tool-button
      :icon="invertSelectionTool.icon"
      :tooltip="$t(invertSelectionTool.label)"
      :disabled="!editMode"
      @buttonClick="emitEvent(invertSelectionTool.event)"
    />

    <!--Clear Selection Tool-->
    <tool-button
      :icon="clearSelectionTool.icon"
      :tooltip="$t(clearSelectionTool.label)"
      :disabled="objects.selected === 0 || !editMode"
      @buttonClick="emitEvent(clearSelectionTool.event)"
    />

    <!--Clone Tool-->
    <!-- TODO -->
    <tool-button
      v-if="false"
      :icon="cloneTool.icon"
      :tooltip="$t(cloneTool.label)"
      :disabled="!canUseTool('store') || objects.selected === 0 || !editMode"
      @buttonClick="emitEvent(cloneTool.event)"
    />

    <!--Add Tool-->
    <tool-button
      :icon="addTool.icon"
      :tooltip="$t(addTool.label)"
      :disabled="!canUseTool('store') || !editMode"
      @buttonClick="
        startAction(objects.edited, 'clearNewObjects', emitEvent, addTool.event)
      "
    />

    <!--Delete Tool-->
    <tool-button
      :icon="deleteTool.icon"
      :tooltip="$t(deleteTool.label)"
      :disabled="!canUseTool('destroy') || objects.selected === 0 || !editMode"
      @buttonClick="dialogs.deleteObjects = true"
    />

    <app-dialog-box
      :open="dialogs.deleteObjects"
      :title="$t('DeleteObjects')"
      :content="$t('CheckDeleteObjects')"
      :main-action-label="$t('No')"
      @mainAction="dialogs.deleteObjects = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="
        executeAction('deleteObjects', emitEvent, deleteTool.event)
      "
    />
  </div>
</template>

<script>
import { bus } from "@/main";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import ToolButton from "../../MultiSelectionForm/ToolButton";
import TrashIcon from "@/assets/home/trash.svg";
import AddIcon from "@/assets/home/add.svg";
import SelectAllIcon from "@/assets/home/selectAll.svg";
import InvertSelectionIcon from "@/assets/home/invertSelection.svg";
import ClearSelectionIcon from "@/assets/home/clearSelection.svg";
import CloneIcon from "@/assets/home/clone.svg";
import AppDialogBox from "../../../../_Molecules/AppDialogBox";
export default {
  name: "CustomerPremisesToolbar",

  components: {
    AppDialogBox,
    ToolButton,
    TrashIcon,
    AddIcon,
    SelectAllIcon,
    InvertSelectionIcon,
    ClearSelectionIcon,
    CloneIcon
  },

  mixins: [checkPermissionsMixin],

  props: {
    layer: {
      type: String,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      addTool: {
        label: "AddSelected",
        icon: AddIcon,
        event: "add"
      },
      deleteTool: {
        label: "DeleteSelected",
        icon: TrashIcon,
        event: "delete"
      },
      cloneTool: {
        label: "CloneSelected",
        icon: CloneIcon,
        event: "clone"
      },
      selectAllTool: {
        label: "SelectAll",
        icon: SelectAllIcon,
        event: "selectAll"
      },
      invertSelectionTool: {
        label: "InvertSelection",
        icon: InvertSelectionIcon,
        event: "invertSelection"
      },
      clearSelectionTool: {
        label: "ClearSelection",
        icon: ClearSelectionIcon,
        event: "clearSelection"
      },

      dialogs: {
        deleteObjects: false
      },

      objects: {
        total: undefined,
        selected: 0,
        edited: false
      }
    };
  },

  computed: {
    permissionName() {
      return this.getPermissionNameByLayer(this.layer);
    }
  },

  mounted() {
    /**
     * Opens a channel to receive updates on the total number of objects
     */
    bus.$on(
      "updateNumberObjects",
      numberObjects => (this.objects.total = numberObjects)
    );
    /**
     * Opens a channel to receive updates on the number of objects selected
     */
    bus.$on(
      "updateNumberSelectedObjects",
      numberSelectedObjects => (this.objects.selected = numberSelectedObjects)
    );
  },

  methods: {
    /**
     * Checks if the action can be immediately executed or not.
     * If not it opens a dialog box for the user to verify that he wants to go through with the action.
     * Else it executes the action immediately.
     * @param {Boolean} dialogCondition - condition to check if a verification is needed or not.
     * @param {String} dialog - name of the variable that controls the appearance of the dialog box.
     * @param action - action to be executed.
     * @param actionParameter - parameter to feed the action
     */
    startAction(dialogCondition, dialog, action, actionParameter) {
      if (dialogCondition) {
        this.dialogs[dialog] = true;
      } else {
        action(actionParameter);
      }
    },

    /**
     * Executes the given action and closes the respective dialog box.
     * @param {String} dialog - name of the variable that controls the appearance of the dialog box.
     * @param action - action to be executed.
     * @param actionParameter
     */
    executeAction(dialog, action, actionParameter = undefined) {
      if (actionParameter !== undefined) {
        action(actionParameter);
      } else {
        action();
      }
      this.dialogs[dialog] = false;
    },

    /**
     * Emits event (for the Multi Selection table) to initiate a certain action.
     * @param {String }eventName -  name of the event to be emitted.
     */
    emitEvent(eventName) {
      bus.$emit(eventName);
    },

    canUseTool(action) {
      return this.userHasFibercloudPermission(this.permissionName, action);
    }
  },

  destroyed() {
    bus.$off("updateNumberObjects");
    bus.$off("updateNumberSelectedObjects");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/CustomerPremises/CustomerPremisesToolbar.vue